function initializeProductSlider() {
  var productSlider = document.querySelectorAll('.product-slider__grid .swiper-container');

  if (!productSlider[0]) {
    return;
  }

  productSlider.forEach(function (slider) {
    var prevButton = document.querySelector('.product-slider .swiper-button-prev');
    var nextButton = document.querySelector('.product-slider .swiper-button-next');
    var productSlider = new Swiper(slider, {
      slidesPerView: 1.3,
      freeMode: true,
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: 2.2,
        },
        1024: {
          slidesPerView: 4,
        },
      },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initializeProductSlider();
});
